export default __webpack_public_path__ + "images/9c86d066adb021cdd56b3e878d23b66d-success_search@2x.png";